import { Action, createActionGroup, emptyProps, props } from "@ngrx/store";
import { JobDetailsV2Fragment, BaseZoneWithParentFragment, Coordinates, CalculateDistanceQuery, Job_LocationsFragment } from "graphql.generated";
import { AccessType, ElevatorType } from "src/app/job/job-overview/overview-locations/overview-locations.state";
import { BuildingSize, BuildingType } from "src/app/shared/location-details-wizard/location-details-wizard.state";
import { ActionSource } from "src/app/state/action-sources";

import { LocationType } from "../../../global.constants";

export const JobLocationsOverviewActions = createActionGroup({
  source: ActionSource.JOB_LOCATIONS_OVERVIEW,
  events: {
    'Location Selected': props<{ locationType: LocationType }>(),
    'Delete Location Button Clicked': emptyProps(),
    'Open Location In Street View Button Clicked': props<{ coordinates: Coordinates }>(),
    'Open Location In Google Maps Button Clicked': emptyProps(),
    'Open Location In Google Button Clicked': emptyProps(),
    'Open Location In Zillow Button Clicked': emptyProps(),
    'Change Area Button Clicked': emptyProps(),
    'Add Location Manually Button Clicked': props<{ locationType: LocationType }>(),
    'Job Location Loaded': props<{
      locationType: LocationType;
      job: JobDetailsV2Fragment;
    }>(),
    'Google Autocomplete Input Changed': props<{ address: string; locationType: string; }>(),
    'Google Autocomplete Address Selected': props<{
      address: google.maps.places.PlaceResult;
      locationType: string;
      openWizard?: boolean;
    }>(),
    'Unit Number Entered': props<{ unitNumber: string; locationType: LocationType; }>(),
    'Size Selected': props<{ size: string; locationType: LocationType; }>(),
    'Access Selected': props<{ access: AccessType; locationType: LocationType; }>(),
    'Elevator Type Selected': props<{ elevatorType: ElevatorType; locationType: LocationType; }>(),
    'Building Type Selected': props<{ buildingType: string; locationType: LocationType; }>(),
    'Floor Input Changed': props<{ floor: number; locationType: LocationType; }>(),
    'Access Notes Text Area Content Changed': props<{ accessNotes: string; locationType: LocationType; }>(),
    'Open Directions Button Clicked': emptyProps(),
    'Address Link Clicked': props<{ locationType: LocationType }>(),
    'Edit Location Button Clicked': props<{ locationType: LocationType }>(),
    'Service Area Selected': props<{ serviceArea: BaseZoneWithParentFragment; promptedBy: Action; hasJob: boolean; }>(),
    'Add Location Link Clicked': emptyProps(),
    'Addable Location Type Selected': props<{ locationType: LocationType }>(),
		'Add Job Location Success': props<{
			updatedJob: JobDetailsV2Fragment;
      locationType: LocationType;
      customSuccessMessage?: string;
		}>(),
		'Delete Job Location Success': props<{
			updatedJob: JobDetailsV2Fragment;
      locationType: LocationType;
		}>(),
		'Add Job Location Error': props<{
      error: Error;
      customErrorMessage?: string;
    }>(),
		'Delete Job Location Error': props<{
      error: Error;
    }>(),
		'Location Changes Detected': props<{
      locationIds: string[];
    }>(),
		'Calculate Distances Success': props<{
      calculateDistancesOutput: CalculateDistanceQuery['calculateDistance'];
    }>(),
		'Calculate Distances Error': props<{
      error: Error;
    }>(),
    'Exit Wizard Button Clicked': emptyProps(),
    'Autocomplete Focused': emptyProps(),
    'Wizard Focused': emptyProps(),
    'Detail Fields Touched': emptyProps(),
    'Navigate To Invalid Location Success': props<{
      locationType: LocationType;
      existingLocation: Job_LocationsFragment['locations'][number]['location'] | undefined;
    }>(),
    'Wizard Details Loaded': props<{
      completed: boolean;
      locationType: LocationType;
      buildingType?: BuildingType;
      size?: BuildingSize;
      access?: AccessType;
      elevatorType?: ElevatorType;
      floor?: number;
    }>(),
  },
})
